import { render, staticRenderFns } from "./myPaginSimple.vue?vue&type=template&id=7d4e3348&"
import script from "./myPaginSimple.vue?vue&type=script&setup=true&lang=js&"
export * from "./myPaginSimple.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports